<template>
  <div class="login">
    <div class="wrapper">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 gl2 xl2 style="z-index: 2;">
            <img src="../assets/logo_DIF_horizontal_bco.png" alt="" width="100%" height="auto">
            <v-card class="elevation-12">
              <v-toolbar dark color="accent">
                <v-layout align-center justify-center>
                  <v-toolbar-title>Usuario</v-toolbar-title>
                </v-layout>
              </v-toolbar>
              <v-card-text>
                <v-form v-model="validLogin" ref="formLogin" lazy-validation>
                  <v-text-field 
                    color="accent" 
                    prepend-icon="person" 
                    name="usuario" 
                    label="Escribe tu nombre" 
                    type="text" 
                    v-model="usuario" 
                    :error-messages="errorMensaje"
                    :rules="[v => !!v || 'El usuario es requerido.']"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-layout align-center justify-center mb-3>
                  <v-btn large color="accent" dark @click="ingresar"> <v-icon dark left>fingerprint</v-icon>Ingresar</v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <ul class="bg-bubbles">
        <li><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></li>
        <li><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></li>
        <li><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></li>
        <li><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></li>
        <li><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></li>
        <li><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></li>
        <li><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></li>
        <li><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></li>
        <li><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></li>
        <li><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import GlogalJS from '../mixins/GlobalJs';
import EventBus from '../event-bus';

export default {
  name: 'Login',
  mixins: [GlogalJS],
  data: () => ({
    show: false,
    usuario:'',
    contrasenia:'',
    errorMensaje:'',
    validLogin: true,
  }),
  methods:{
    ingresar(){
      this.errorMensaje = '';
      EventBus.$emit('change:SignIn', this.usuario);
      localStorage.setItem('usuario', JSON.stringify(this.usuario));
      // this.$router.push({ name: 'Home', params: { servicio: 'hola' } });
      this.$router.push({ name: 'Home' });
    }
  }
}
</script>

<style>
.login{
  width: inherit;
  height: inherit;
}

.login .wrapper {
  background: #49a9c4;
  background: linear-gradient(to bottom right, #2ebab0 0%, #177d99 100%);
  position: absolute;
  left: 0;
  width: 100%;
  height: calc(100% + 10px);
  margin-top: -24px;
  overflow: hidden;
}
.login .wrapper.form-success .container h1 {
  -webkit-transform: translateY(85px);
          transform: translateY(85px);
}

.login .bg-bubbles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.login .bg-bubbles li {
  position: absolute;
  list-style: none;
  display: block;
  width: 40px;
  height: 40px;
   opacity: 0.25;
  bottom: -160px;
  -webkit-animation: square 25s infinite;
  animation: square 25s infinite;
  transition-timing-function: linear;
}
.login .bg-bubbles li:nth-child(1) {
  left: 10%;
   opacity: 0.55;
}
.login .bg-bubbles li:nth-child(2) {
  left: 20%;
  width: 80px;
  height: 80px;
  -webkit-animation-delay: 2s;
          animation-delay: 2s;
  -webkit-animation-duration: 17s;
          animation-duration: 17s;
           opacity: 0.1;
}
.login .bg-bubbles li:nth-child(3) {
  left: 25%;
  -webkit-animation-delay: 4s;
          animation-delay: 4s;
          opacity: 0.25;
}
.login .bg-bubbles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  -webkit-animation-duration: 22s;
          animation-duration: 22s;
          opacity: 0.25;
}
.login .bg-bubbles li:nth-child(5) {
  left: 70%;
}
.login .bg-bubbles li:nth-child(6) {
  left: 80%;
  width: 120px;
  height: 120px;
  -webkit-animation-delay: 3s;
          animation-delay: 3s;
          opacity: 0.2;
}
.login .bg-bubbles li:nth-child(7) {
  left: 32%;
  width: 160px;
  height: 160px;
  -webkit-animation-delay: 7s;
          animation-delay: 7s;
          opacity: 0.5;
}
.login .bg-bubbles li:nth-child(8) {
  left: 55%;
  width: 20px;
  height: 20px;
  -webkit-animation-delay: 15s;
          animation-delay: 15s;
  -webkit-animation-duration: 40s;
          animation-duration: 40s;
          opacity: 0.15;
}
.login .bg-bubbles li:nth-child(9) {
  left: 25%;
  width: 10px;
  height: 10px;
  -webkit-animation-delay: 2s;
          animation-delay: 2s;
  -webkit-animation-duration: 40s;
          animation-duration: 40s;
          opacity: 0.3;
}
.login .bg-bubbles li:nth-child(10) {
  left: 90%;
  width: 160px;
  height: 160px;
  opacity: 0.35;
  -webkit-animation-delay: 11s;
          animation-delay: 11s;
}
@-webkit-keyframes square {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-1150px) rotate(600deg);
            transform: translateY(-1150px) rotate(600deg);
  }
}
@keyframes square {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-1150px) rotate(600deg);
            transform: translateY(-1150px) rotate(600deg);
  }
}
</style>
